export default __webpack_public_path__ + "b0f10392466d1ef1a40400358d8a2472.jpg";